import { render, staticRenderFns } from "./CancelPickupModal.vue?vue&type=template&id=53ccfa22&scoped=true"
import script from "./CancelPickupModal.vue?vue&type=script&lang=ts"
export * from "./CancelPickupModal.vue?vue&type=script&lang=ts"
import style0 from "./CancelPickupModal.vue?vue&type=style&index=0&id=53ccfa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ccfa22",
  null
  
)

export default component.exports